var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-department-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v("Departman Seçimi")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: {
              placeholder: "Departman seçin",
              "filter-option": _vm.filterOption,
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.departmentId,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "departmentId", $$v)
              },
              expression: "localConfig.departmentId",
            },
          },
          _vm._l(_vm.departments, function (dept) {
            return _c(
              "a-select-option",
              { key: dept._id, attrs: { value: dept._id } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getDepartmentName(dept)) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "Seçilen departman kişinin ilgili departmanlar listesine eklenecektir"
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.whenType === "chat_opened"
      ? _c(
          "div",
          { staticClass: "config-field" },
          [
            _c(
              "a-checkbox",
              {
                on: { change: _vm.emitChange },
                model: {
                  value: _vm.localConfig.applyToConversation,
                  callback: function ($$v) {
                    _vm.$set(_vm.localConfig, "applyToConversation", $$v)
                  },
                  expression: "localConfig.applyToConversation",
                },
              },
              [_vm._v("\n            Konuşmaya da uygula\n        ")]
            ),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Aktif edilirse, açılan konuşmanın departmanı da bu departman olarak ayarlanır"
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }